'use client';

import { useBulkTabStore } from '@/store';
import { useEffect, useRef } from 'react';

export const GlobalBeforeUnloadListener = () => {
  const { initialize, onUnload } = useBulkTabStore();
  const hasBound = useRef(false);
  useEffect(() => {
    if (hasBound.current) return;
    hasBound.current = true;

    initialize();

    window.addEventListener('beforeunload', onUnload);
    return () => window.removeEventListener('beforeunload', onUnload);
  }, [initialize, onUnload]);

  return null;
};
